
export enum MobileType {
  IOS = 'iOS',
  ANDROID = 'Android',
}
